module.exports = "/images/Concrete---Hero.jpg";